/* eslint-disable */
export default {
    v: '5.5.8',
    fr: 30,
    ip: 0,
    op: 86,
    w: 640,
    h: 640,
    nm: 'Comp 3',
    ddd: 0,
    assets: [
        {
            id: 'comp_0',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 3,
                    nm: 'Null 1',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 0, ix: 11 },
                        r: {
                            a: 1,
                            k: [
                                { i: { x: [0.667], y: [1] }, o: { x: [0.874], y: [0.002] }, t: 62, s: [0] },
                                { t: 85, s: [360] },
                            ],
                            ix: 10,
                        },
                        p: { a: 0, k: [540, 540, 0], ix: 2 },
                        a: { a: 0, k: [-22, 0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100, 100], ix: 6 },
                    },
                    ao: 0,
                    ip: 0,
                    op: 900,
                    st: 0,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: 'Shape Layer 2',
                    parent: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 180, ix: 10 },
                        p: { a: 0, k: [-71, -28, 0], ix: 2 },
                        a: { a: 0, k: [0, 0, 0], ix: 1 },
                        s: { a: 0, k: [104.401, 100, 100], ix: 6 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.167, y: 0.167 },
                                                t: 13,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-54.597, -140],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-54.597, 100],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 17,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-92.432, -140],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-91.953, 100],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                            {
                                                i: { x: 0.833, y: 0.833 },
                                                o: { x: 0.333, y: 0 },
                                                t: 32,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-92.432, -140],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-91.953, 100],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                            {
                                                t: 37,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-48.858, -258.359],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-46.787, 211.467],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: [0.833], y: [0.833] },
                                                o: { x: [0.167], y: [0.167] },
                                                t: 32,
                                                s: [45],
                                            },
                                            { t: 37, s: [68] },
                                        ],
                                        ix: 5,
                                    },
                                    lc: 2,
                                    lj: 1,
                                    ml: 4,
                                    bm: 0,
                                    nm: 'Stroke 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                                    o: { a: 0, k: 1, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Shape 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: -54,
                    op: 846,
                    st: -54,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 4,
                    nm: 'Shape Layer 1',
                    parent: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [26, 12, 0], ix: 2 },
                        a: { a: 0, k: [0, 0, 0], ix: 1 },
                        s: { a: 0, k: [104.401, 100, 100], ix: 6 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.167, y: 0.167 },
                                                t: 13,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-38.314, -140],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-38.314, 100],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                            {
                                                i: { x: 0.667, y: 1 },
                                                o: { x: 0.333, y: 0 },
                                                t: 17,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-94.827, -140],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-94.348, 100],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                            {
                                                i: { x: 0.833, y: 0.833 },
                                                o: { x: 0.333, y: 0 },
                                                t: 32,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-94.827, -140],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-94.348, 100],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                            {
                                                t: 37,
                                                s: [
                                                    {
                                                        i: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        o: [
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                            [0, 0],
                                                        ],
                                                        v: [
                                                            [-50.805, -251.489],
                                                            [-267.239, -140],
                                                            [-267.239, -102],
                                                            [-267.239, 100],
                                                            [-47.318, 218.859],
                                                        ],
                                                        c: false,
                                                    },
                                                ],
                                            },
                                        ],
                                        ix: 2,
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 1,
                                        k: [
                                            {
                                                i: { x: [0.833], y: [0.833] },
                                                o: { x: [0.167], y: [0.167] },
                                                t: 32,
                                                s: [45],
                                            },
                                            { t: 37, s: [68] },
                                        ],
                                        ix: 5,
                                    },
                                    lc: 2,
                                    lj: 1,
                                    ml: 4,
                                    bm: 0,
                                    nm: 'Stroke 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
                                    o: { a: 0, k: 1, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform',
                                },
                            ],
                            nm: 'Shape 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                    ],
                    ip: -54,
                    op: 846,
                    st: -54,
                    bm: 0,
                },
            ],
        },
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 0,
            nm: 'Comp 1',
            refId: 'comp_0',
            sr: 1,
            ks: {
                o: {
                    a: 1,
                    k: [
                        { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 3, s: [0] },
                        { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 8, s: [100] },
                        { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 62, s: [100] },
                        { t: 80, s: [0] },
                    ],
                    ix: 11,
                },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [326, 324, 0], ix: 2 },
                a: { a: 0, k: [540, 540, 0], ix: 1 },
                s: {
                    a: 1,
                    k: [
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, -8.514] },
                            t: 2,
                            s: [31.222, 31.222, 100],
                        },
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
                            t: 18,
                            s: [52.222, 52.222, 100],
                        },
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                            t: 28,
                            s: [52.222, 52.222, 100],
                        },
                        {
                            i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                            o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                            t: 34,
                            s: [59.222, 59.222, 100],
                        },
                        {
                            i: { x: [0.612, 0.612, 0.612], y: [1, 1, 1] },
                            o: { x: [0.16, 0.16, 0.16], y: [0, 0, 0] },
                            t: 40,
                            s: [47.222, 47.222, 100],
                        },
                        {
                            i: { x: [0.697, 0.697, 0.697], y: [1, 1, 1] },
                            o: { x: [0.356, 0.356, 0.356], y: [0, 0, 0] },
                            t: 58,
                            s: [47.222, 47.222, 100],
                        },
                        {
                            i: { x: [0.789, 0.789, 0.789], y: [1, 1, 1] },
                            o: { x: [0.434, 0.434, 0.434], y: [0, 0, 0] },
                            t: 63,
                            s: [61.222, 61.222, 100],
                        },
                        {
                            i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
                            o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
                            t: 68,
                            s: [47.222, 47.222, 100],
                        },
                        { t: 83, s: [10.222, 10.222, 100] },
                    ],
                    ix: 6,
                },
            },
            ao: 0,
            w: 1080,
            h: 1080,
            ip: 0,
            op: 900,
            st: 0,
            bm: 16,
        },
    ],
    markers: [],
}
